module.exports = __webpack_public_path__ + "img/img3.89a02071.png";